// 埋点配置
export const POINT_CONFIG = {
  // 埋点记录类型
  REC_TYPE: {
    SEND: 1, // 发送
    SEND_SUCCESS: 2, // 发送成功
    FORWARD: 3, // 转发
    FORWARD_SUCCESS: 4, // 转发成功
    OPEN: 5, // 打开
    TRANSACT: 15, // 立即办理
  },

  // 分享渠道类型
  SHARE_CHANNEL: {
    FORWARD: 1, // 转发分享
    WECHAT: 2, // 微信好友分享
    TIMELINE: 3, // 朋友圈分享
    GROUP_SHARE: 4, // 群发客户分享
    GROUP_SHARE_GROUP: 5, // 群发客户群分享
    WECHAT_ALL: 6, // 微信
    QYWECHAT_TIMELINE: 11, // 企业微信朋友圈
    POSTER_SHARE: 12, // 海报长按图片分享
    PRODUCT_POSTER_SHARE: 13, // 长按图片分享
  },
  // 快照类型
  SNAPSHOT_TYPE: {
    NEWS: 0, // 新闻
    PRODUCT: 1, // 产品
    MORNING_NEWS: 2, // 早报
    STATION: 3, // 小站
    ACTIVE: 4, // 活动
    NOON_PAPER: 7, // 午间趣谈
    YX_ACTIVE: 8, // 营销活动
    HOTSPOTINTERPRETATION: 9, // 热点解读
    INTERACT_TOPIC: 11, // 互动话题
    NEWS_SUBJECTS: 12, // 资讯专题
    THIRD_PARTY_PRODUCT: 13, // 第三方产品
    THIRD_PARTY_NEWS: 14, // 第三方资讯
    FESTIVAL_CARE: 15, // 节点关怀
    FESTIVAL_CARE_POSTER: 16, // 节点关怀-生成海报
    LIVING_BROADCAST: 17, // 直播
    POSTER: 18, // 海报
    MOMENTS: 19, // 朋友圈神器
    PERSONAL_IMPRESSION: 21, //个人印象
    VIDEO: 23, // 视频
    QUESTIONNAIRE: 24, // (春节)问卷
    EVENING_PAPER: 25, // 财富晚报
  },
  /*
   * 分享链路
   */
  // 内容类别
  CONTENT_TYPE: {
    PRODUCT: 1, // 产品
    ARTICLE: 2, // 文章
    PAGE: 3, // 页面
    SOP: 4, // SOP
    TOPIC: 5, // 话题
    SEND_MESSAGE: 6, // 发起会话
    ADD_FOLLOW_ORDINARY: 7, // 填写跟进记录
    SEND_POSTER: 8, // 发海报
    ADD_LABEL: 9, // 打标签
    MASS: 10, // 群发
  },
  // 操作类别
  OPERATION_TYPE: {
    VIEW: 1, // 查看
    SHARE: 2, // 分享
    IMPLEMENT: 3, // 执行（保存、添加、发起,
    CALL: 4, // 打电话
  },

  // 埋点-动线来源标识
  SOURCE_ID: {
    QT: 0, // 其他-未知来源
    YXZS: 1, // 营销助手
    WZXQ: 2, // 文章详情页跳转产品
    JRDB: 3, // 今日待办
    QLXZS: 4, // 麒麟小助手
    WZK: 5, // 文章库
    BANNER: 6, // 活动banner
    FXXQY: 7, // 分享详情页
    ZB: 8, // 早报
    XZ: 9, // 小站 / 云工作室
    CBL: 10, // 侧边栏
    JJYL: 11, // 基金有料
    CPK: 12, // 产品库
    HB_TZ_CP: 13, // 海报跳转产品
    JJYL_YXSC_WZ: 14, // 基金有料->营销素材库->素材详情
    JJYL_YXJH: 15, // 基金有料->营销机会
    JJYL_HOT_ARTICLE: 16, // 基金有料->热点文章
    JJYL_HOT_PRODUCT: 17, // 基金有料->主推产品
    SOP: 18, // sop详情
    SOP_MSG: 19, // sop营销机会->消息通知
    SOP_MARKETING: 20, // sop营销机会
    JR_TO_FE: 21, // 今日代办跳转节点关怀
    FE_PRO: 22, // 节点关怀到产品
    GROUP_ROBOT: 23, // 群机器人
    QUESTIONNAIRE: 26, // 问卷
    GZH: 24, // 公众号
    ZD_MAGIC_PAGE: 25, // 智搭页面
    ARTICLE_RECOMMEND: 27, // 推荐阅读
    MOMENTS: 28, // 朋友圈神器—文章	28
    ARTICLE_TOPIC: 29, // 专题页面—文章	29
    JJYL_PRODUCT_TAB: 30, // 基金有料产品tab -> 产品
    DISCOVERY: 31, // 发现页
  },
  // 页面埋点ID
  PAGE_ID: {
    ZCPZ: 1, // 资产配置小工具/四笔钱
  },
  // 埋点类型
  BURIED_TYPE: {
    BUSINESS: 0, // 0 为业务埋点
    PAGE: 1, // 1为页面埋点
  },

  // SOP详情页，埋点来源
  SOP_SOURCE: {
    message: '1', // 消息通知
    marketing: '2', // 营销机会
    fund: '3', // 基金有料
    discovery: '4', // 发现
  },
} as const;
